import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const BrandContext = createContext(null);

const DEFAULTS = {
  brand_name: "RENTAL.PS",
  brand_logo_base64: "",
  theme_primary: "#00E5FF",
  theme_accent: "#FF0055",
  business_name: "",
};

function applyTheme(primary, accent) {
  if (typeof document === "undefined") return;
  const root = document.documentElement;
  if (primary) root.style.setProperty("--brand-primary", primary);
  if (accent) root.style.setProperty("--brand-accent", accent);
}

export function BrandProvider({ children }) {
  const [brand, setBrand] = useState(DEFAULTS);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/settings");
      const merged = {
        brand_name: data.brand_name || DEFAULTS.brand_name,
        brand_logo_base64: data.brand_logo_base64 || "",
        theme_primary: data.theme_primary || DEFAULTS.theme_primary,
        theme_accent: data.theme_accent || DEFAULTS.theme_accent,
        business_name: data.business_name || "",
      };
      setBrand(merged);
      applyTheme(merged.theme_primary, merged.theme_accent);
    } catch (e) {
      applyTheme(DEFAULTS.theme_primary, DEFAULTS.theme_accent);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return (
    <BrandContext.Provider value={{ ...brand, refresh }}>
      {children}
    </BrandContext.Provider>
  );
}

export const useBrand = () => useContext(BrandContext) || DEFAULTS;
